import type { EditorView } from '@tiptap/pm/view';

/**
 * ProseMirror's domAtPos can throw or return unusable results when the document
 * and DOM are out of sync (e.g. during React unmount, route change, or mid-transaction).
 * Use this before mapping positions to DOM nodes from UI callbacks (BubbleMenu, etc.).
 */
export function safeDomAtPos(
  view: EditorView | null | undefined,
  pos: number
): { node: Node; offset: number } | null {
  if (!view?.dom?.isConnected) {
    return null;
  }
  try {
    const result = view.domAtPos(pos);
    if (!result || result.node == null) {
      return null;
    }
    return result;
  } catch {
    return null;
  }
}
